import { API } from "../utils";

export const getDashboardData = async ({ from, to } = {}) => {
  const response = API.get("/organization/dashboard", {
    params: { from, to },
  });
  const data = await response;
  return data.data;
};

export const getUserDashboardData = async ({ from, to } = {}) => {
  const response = API.get("/auth/dashboard", {
    params: { from, to },
  });
  const data = await response;
  return data.data;
};

export const getDashboardActivities = async ({ params }) => {
  const response = API.get("/organization/activities", { params });
  const data = await response;
  return data.data;
};

export const getOrgActivities = async ({ params }) => {
  const response = API.get("/organization/activities", { params });
  const data = await response;
  return data;
};
